import React from "react";
import Header from "../../Components/Header/Header";
import ProjectsItems from "./ProjectsItems/ProjectsItems";
import { useTranslation } from "react-i18next";
import Breadcrumb from "../../Components/Breadcrumb/Breadcrumb";

const Projects = () => {
  const { t, i18n } = useTranslation();

  return (
    <>
      <Breadcrumb title={t("Layihələr")} />

      <ProjectsItems />
    </>
  );
};

export default Projects;
